import { Component, OnInit, inject } from '@angular/core';
import { campusData, facilityData, functionalAreasData, locationData } from 'src/app/data/location_data';
import { MaapLocation } from 'src/app/models/location';
import { UtilityService } from 'src/app/services/utility.service';



@Component({
    selector: 'app-add-location',
    templateUrl: './add-location.component.html',
    styleUrls: ['./add-location.component.css'],
    standalone: false
})
export class AddLocationComponent implements OnInit {
  private utilityService = inject(UtilityService);

  isNewRegion = false;
  isNewCampus = false;
  isNewFacility = false;
  isNewFacilityLocation = false;
  isNewFunctionalArea = false;
  selectedLocation: any = {};
  regions: any[] = [];
  campuses = campusData;
  facilities = facilityData;
  facilityLocations = locationData;
  functionalAreas = functionalAreasData;
  locations: MaapLocation[] = [];

  ngOnInit(): void {
    this.loadLocationData();
  }

  reset() {
    this.selectedLocation = {};
  }

  loadLocationData() {
    // this.accountManagementService.getLocations().subscribe((res) => {
    //   this.locations = res;
    //   this.getRegionOptions();
    // });
  }

  getRegionOptions() {
    this.regions = this.utilityService.removeDuplicate2s(this.locations.map((item) => { return { "label": item.region, "value": item.region } }));
  }

  loadCampusOptions() {
    this.campuses = this.utilityService.removeDuplicate2s(this.locations.filter((item) => item.region == this.selectedLocation.region.label).map((item) => { return { "label": item.campus, "value": item.campus } }));
  }

  loadFacilityOptions() {
    this.facilities = this.utilityService.removeDuplicate2s(
      this.locations.filter(
        (item) =>
          item.campus == this.selectedLocation.campus.label
          && item.region == this.selectedLocation.region.label
      ).map(
        (item) => { return { "label": item.facility, "value": item.facility } }
      )
    );
  }

  loadLocationOptions() {
    this.facilityLocations = this.utilityService.removeDuplicate2s(
      this.locations.filter(
        (item) =>
          item.campus == this.selectedLocation.campus.label
          && item.region == this.selectedLocation.region.label
          && item.facility == this.selectedLocation.facility.label
      ).map(
        (item) => { return { "label": item.facilityLocation, "value": item.facilityLocation } }
      )
    );
  }

  loadFunctionalAreaOptions() {
    this.functionalAreas = this.utilityService.removeDuplicate2s(
      this.locations.filter(
        (item) =>
          item.campus == this.selectedLocation.campus.label
          && item.region == this.selectedLocation.region.label
          && item.facility == this.selectedLocation.facility.label
          && item.facilityLocation == this.selectedLocation.facilityLocation.label
      ).map(
        (item) => { return { "label": item.functionalArea, "value": item.functionalArea } }
      )
    );
  }

}
